
String.prototype.cop = function () {
    return this.replace(/,/g,'~').replace(/\./g,',').replace(/~/g,'.')
}

export const _store = (_KEY, _VALUE) => {
    try {
        localStorage.setItem(_KEY, _VALUE);
    } catch (error) {
        console.log("Error al salvar datos locales!!", error);
    }
};

export let _retrieveData = (_KEY) => {
    // try {
    const value = localStorage.getItem(_KEY)
    if (value !== null) {
        return value;
    } else {
        return null;
    }
    // } catch (error) {
    //     console.log('Error retrieving : ',_KEY)
    //     return null
    // }
};

export let _deleteKey = (_KEY) => {
    localStorage.removeItem(_KEY)
}


export let formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
})

export let getTimeDate = () => {
    var date = new Date();
    var nDay = date.getDay();
    var day = date.getDate();
    var month = date.getMonth() ; //Current Month
    var year = date.getFullYear(); //Current Year
    var hours = date.getHours(); //Current Hours
    var min = date.getMinutes(); //Current Minutes
    var sec = date.getSeconds(); //Current Seconds
    return (year+"-"+("00"+(month+1)).slice(-2)+"-"+("00"+(day)).slice(-2)+" "+("00"+(hours)).slice(-2)+":"+("00"+(min)).slice(-2)+":"+("00"+(sec)).slice(-2) )
}


export let  fnExcelReport = (HTML, TITULO) => {
    var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
    tab_text = tab_text + '<head> <meta charset="utf-8"><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>';

    tab_text = tab_text + '<x:Name>Test Sheet</x:Name>';

    tab_text = tab_text + '<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>';
    tab_text = tab_text + '</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>';

    tab_text = tab_text + "<table border='1px'>";
    tab_text += `<h2 align="center">CONSORCIO SANTA MARTA ILUMINADA Y SEGURA<br>Empresa Regional de Servicios Públicos S.A. E.S.P. (Semsa S.A. E.S.P.) y Energeza Global Engineering S.A. (Energeza GB S.A.)<br>Nit 900.299.692-5</h2><br><h1 align="center">Software de Cartera Alumbrado Público - ${TITULO}</h1><br>`;
    tab_text +=  HTML
    tab_text = tab_text + '</table></body></html>';

    var data_type = 'data:application/vnd.ms-excel';
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    return {data_type,tab_text}
}

export let myUTF8 = (s) => {
    var caracter;
    var result = "";
    for(var i=0;i<=s.length;i++){
        //// console.log(s.substr(i,1));
        switch(s.substr(i,1)){
            case "Á": caracter = "&Aacute;";break;
            case "É": caracter = "&Eacute;";break;
            case "Í": caracter = "&Iacute;";break;
            case "Ó": caracter = "&Oacute;";break;
            case "Ú": caracter = "&Uacute;";break;
            case "á": caracter = "&Aacute;";break;
            case "é": caracter = "&eacute;";break;
            case "í": caracter = "&iacute;";break;
            case "ó": caracter = "&oacute;";break;
            case "ú": caracter = "&uacute;";break;
            case "Ü": caracter = "&Uuml;";break;
            case "ü": caracter = "&uuml;";break;
            default:
                caracter = s.substr(i,1);
        }
        result += caracter;
    }
    return result;
}
